module.exports = __webpack_public_path__ + "static/media/f-story-icon.d28e489b.png";